var _defs, _g, _g2, _g3, _g4, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "171e48eea3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 490 309 L 762.160156 309 L 762.160156 545 L 490 545 Z M 490 309 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eb8fdeb321"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 165 218.550781 L 402 218.550781 L 402 465 L 165 465 Z M 165 218.550781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5940b1cb05"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48.160156 309 L 320 309 L 320 545 L 48.160156 545 Z M 48.160156 309 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3a46a7f930"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 409 218.550781 L 646 218.550781 L 646 465 L 409 465 Z M 409 218.550781 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#171e48eea3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d335c",
    d: "M 650.941406 309.5625 L 490.894531 469.761719 C 511.882812 489.019531 525.160156 515.269531 526.730469 544.367188 L 762.015625 543.796875 C 759.160156 453.070312 717.042969 367.765625 650.941406 309.5625 Z M 650.941406 309.5625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eb8fdeb321)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4368fe",
    d: "M 165.375 304.425781 L 325.421875 464.769531 C 345.839844 448.222656 372.25 438.09375 401.234375 437.09375 L 401.234375 218.550781 C 310.429688 219.550781 227.765625 251.789062 165.375 304.425781 Z M 165.375 304.425781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5940b1cb05)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#68d7b0",
    d: "M 319.570312 469.761719 L 159.664062 309.5625 C 93.417969 367.765625 51.15625 453.5 48.300781 544.226562 L 283.589844 544.367188 C 285.304688 515.269531 298.582031 489.019531 319.570312 469.761719 Z M 319.570312 469.761719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3a46a7f930)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2740a4",
    d: "M 409.230469 218.550781 L 409.230469 437.09375 C 438.210938 437.949219 464.625 448.222656 485.039062 464.769531 L 645.085938 304.425781 C 582.695312 251.789062 500.03125 219.550781 409.230469 218.550781 Z M 409.230469 218.550781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#474647",
    d: "M 398.949219 499.433594 C 396.949219 499.71875 394.953125 500.003906 392.953125 500.433594 C 430.214844 443.226562 503.601562 334.671875 503.601562 334.671875 C 503.601562 334.671875 465.480469 460.0625 444.636719 524.398438 C 444.351562 523.828125 444.066406 523.257812 443.636719 522.542969 C 442.066406 519.832031 440.351562 517.265625 438.210938 514.980469 C 428.503906 503.710938 413.796875 497.863281 398.949219 499.433594 Z M 398.949219 499.433594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#474647",
    d: "M 446.777344 551.785156 C 448.0625 543.796875 446.921875 535.523438 443.636719 527.964844 C 443.066406 526.535156 442.351562 525.253906 441.636719 523.96875 C 440.210938 521.402344 438.496094 518.976562 436.5 516.695312 C 435.070312 514.980469 433.355469 513.414062 431.644531 511.988281 C 422.648438 504.285156 410.941406 500.574219 399.234375 501.859375 C 396.378906 502.144531 393.667969 502.714844 390.953125 503.570312 C 385.816406 505.28125 380.960938 507.992188 376.820312 511.558594 C 368.394531 518.832031 363.398438 529.105469 362.828125 540.230469 C 362.257812 551.5 365.96875 562.484375 373.535156 571.1875 C 389.097656 589.019531 415.796875 591.300781 433.070312 576.324219 C 440.351562 570.046875 445.207031 561.34375 446.777344 551.785156 Z M 414.082031 554.78125 C 408.515625 559.917969 399.804688 559.773438 394.667969 554.210938 C 389.527344 548.648438 389.667969 539.945312 395.238281 534.8125 C 400.804688 529.675781 409.515625 529.816406 414.65625 535.382812 C 419.792969 540.800781 419.507812 549.503906 414.082031 554.78125 Z M 414.082031 554.78125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.fa909eb6d0e0153655636b157eccd91b.svg";
export { ForwardRef as ReactComponent };